// Viewport signal — tamanho real da tela renderizando.
//
// `effectiveWidth = screen.width × devicePixelRatio` cobre TVs 4K que
// reportam screen.width=1920 mas têm DPR=2 (alguns Tizen). Usado pra
// decidir backdrop preset (sd/hd/fhd/uhd) e poster preset.
//
// Em TV viewport não muda durante a sessão — pode cachear. Em web
// responsivo muda; capabilities expõem subscribe pra resize.

export type ViewportTier = 'sd' | 'hd' | 'fhd' | 'uhd'

export interface ViewportSignal {
  width: number
  height: number
  dpr: number
  /** width × dpr — equivalente ao tamanho real da imagem que vai renderizar. */
  effectiveWidth: number
  tier: ViewportTier
}

export function readViewportSignal(): ViewportSignal {
  if (typeof screen === 'undefined' || typeof window === 'undefined') {
    // SSR fallback — assume FHD (caso comum)
    return { width: 1920, height: 1080, dpr: 1, effectiveWidth: 1920, tier: 'fhd' }
  }
  const dpr = window.devicePixelRatio || 1
  const width = screen.width
  const height = screen.height
  const effectiveWidth = width * dpr

  let tier: ViewportTier
  if (effectiveWidth <= 854) tier = 'sd' // 480p e abaixo (raro em TV moderna)
  else if (effectiveWidth <= 1280) tier = 'hd' // 720p
  else if (effectiveWidth <= 1920) tier = 'fhd' // 1080p
  else tier = 'uhd' // 4K+

  return { width, height, dpr, effectiveWidth, tier }
}
